import { useState } from "react";
import { Minus, Plus, Check } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { formatPrice } from "../lib/api";
import { useCart } from "../context/CartContext";

export const ProductModal = ({ product, onClose }) => {
  const { add } = useCart();
  const [qty, setQty] = useState(1);
  const [active, setActive] = useState(0);
  const gallery = product ? (product.images?.length ? product.images : [product.image]) : [];

  return (
    <Dialog open={!!product} onOpenChange={(o) => { if (!o) { onClose(); setActive(0); } }}>
      <DialogContent data-testid="product-modal" aria-describedby={undefined} className="max-w-4xl gap-0 overflow-hidden border-0 p-0 sm:rounded-none">
        {product && (
          <div className="grid md:grid-cols-2">
            <div className="relative flex flex-col bg-ice">
              <div className="relative aspect-square md:flex-1">
                <img src={gallery[active] || product.image} alt={product.name} data-testid="modal-main-image" className="absolute inset-0 h-full w-full object-cover" />
              </div>
              {gallery.length > 1 && (
                <div className="flex gap-2 overflow-x-auto p-3" data-testid="modal-gallery">
                  {gallery.map((src, i) => (
                    <button key={src} data-testid={`modal-thumb-${i}`} onClick={() => setActive(i)} className={`h-16 w-16 shrink-0 overflow-hidden border-2 transition-colors ${i === active ? "border-royal" : "border-transparent hover:border-navy/30"}`}>
                      <img src={src} alt="" className="h-full w-full object-cover" />
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className="flex flex-col p-8 lg:p-10">
              <p className="eyebrow text-royal">{product.category}</p>
              <DialogTitle className="mt-3 font-display text-2xl font-bold leading-tight text-navy sm:text-3xl">{product.name}</DialogTitle>
              <DialogDescription className="mt-4 text-sm leading-relaxed text-slate-600">{product.description}</DialogDescription>
              {product.specs?.length > 0 && (
                <ul className="mt-6 space-y-2">
                  {product.specs.map((s) => (
                    <li key={s} className="flex items-start gap-2 text-sm text-slate-700"><Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" />{s}</li>
                  ))}
                </ul>
              )}
              <div className="mt-auto pt-8">
                <div className="flex items-center justify-between border-t border-navy/10 pt-6">
                  <span className="font-display text-3xl font-bold text-navy" data-testid="modal-price">{formatPrice(product.price)}</span>
                  <span className={`font-mono text-xs uppercase tracking-widest ${product.stock > 0 ? "text-emerald-600" : "text-red-500"}`}>
                    {product.stock > 0 ? `${product.stock} en stock` : "Rupture"}
                  </span>
                </div>
                <div className="mt-6 flex gap-3">
                  <div className="flex items-center border border-navy/15">
                    <button data-testid="modal-qty-minus" onClick={() => setQty(Math.max(1, qty - 1))} className="grid h-12 w-12 place-items-center hover:bg-ice"><Minus className="h-4 w-4" /></button>
                    <span data-testid="modal-qty" className="w-10 text-center font-semibold">{qty}</span>
                    <button data-testid="modal-qty-plus" onClick={() => setQty(qty + 1)} className="grid h-12 w-12 place-items-center hover:bg-ice"><Plus className="h-4 w-4" /></button>
                  </div>
                  <button
                    data-testid="modal-add-to-cart"
                    disabled={product.stock <= 0}
                    onClick={() => { add(product, qty); onClose(); }}
                    className="btn-primary flex-1 justify-center rounded-none disabled:opacity-40"
                  >
                    Ajouter au panier
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
